import { type MetaFunction } from "@remix-run/node"
import { PageBodyWithClassName, PageContainer } from "#app/components/ui/layout"
import { ABOUT_PAGE, getMetaInfoForPages, getSocialMetas } from "#app/utils/seo"

export const meta: MetaFunction = () => {

  const {title, description,url, keywords, image } = getMetaInfoForPages(ABOUT_PAGE)

  return [
    { viewport: 'width=device-width,initial-scale=1,viewport-fit=cover' },
		...getSocialMetas({
			keywords,
			url,
			image,
			title,
			description,
		}),
  ]
}

export default function AboutRoute() {
	return (
	  <PageBodyWithClassName className="pt-0">
      <PageContainer className="px-0">

      <section className="pt-12 pb-12 lg:pt-24 lg:pb-12">
      <div className="container mx-auto px-4">
		<div className="max-w-3xl mx-auto">

            <div className="mb-6 text-center">
				<h2 className="text-3xl font-semibold tracking-tighter text-center sm:text-4xl md:text-5xl">About Us</h2>
				<p className="mx-auto max-w-[700px] text-muted-foreground md:text-xl/relaxed lg:text-base/relaxed xl:text-xl/relaxed">
				 Let's upgrade your FDs
                </p>
			</div>

			<div className="max-w-3xl mx-auto">
				<p className="py-4 pb-2 text-body-md text-muted-foreground">
				 99% of FDs in India earn less than 9% p.a.
				</p>
				<p className="pb-4 text-body-md text-muted-foreground">
				 95% of FDs in India earn less than 8% p.a.
				</p>
				<p className="py-4 text-body-md text-muted-foreground">
				 Our goal is simple: To put you in that Top 1%.
				</p>
				<p className="py-4 text-body-md text-muted-foreground">
				 Your FDs are not earning as much as they can. We’re on a mission to fix that. 
				</p>

                <div className="pb-4 text-body-md text-muted-foreground">
					<p className="py-4 text-body-md text-muted-foreground">
					With Super FD, you can easily compare, invest, and manage your FDs-all from the comfort of your home. 
					</p>
					<ul className="space-y-1 list-disc list-inside">
						<li>
						Best-in-class rates up to 9.1% p.a.
						</li>
						<li>
						No new savings account needed
						</li>
						<li>
						Seamless booking process
						</li>
						<li>
						RBI-backed insurance on your deposits
						</li>
					</ul>
				</div>

				<p className="py-4 text-body-md text-muted-foreground">
				It's time to rethink what Fixed Deposits can do for you: offering better returns, seamless booking, and the reliability you love.
				</p>

				<p className="py-4 text-body-md text-muted-foreground">
                 Welcome to the new age of smarter, faster, Super FDs!
				</p>
         
			</div>
			
		</div>
	  </div>
	  </section>

	  </PageContainer>
	  </PageBodyWithClassName>
	)
}
